import type { ActivityPeriodOption } from "../../types";

/**
 * Ranges the Activity & performance filter offers. One list, because one
 * dropdown in the section header now drives every card — so the range has to be
 * one all five endpoints can answer, which keeps it to the day/week/month view.
 */
export const ACTIVITY_PERIOD_OPTIONS: ActivityPeriodOption[] = [
  { label: "Today", value: "today" },
  { label: "This week", value: "this_week" },
  { label: "This month", value: "this_month" },
  { label: "Last month", value: "previous_month" },
];
